/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';

const Home = lazy(() => import('@/features/public/components/Home'));
const ComponentShowcase = lazy(() => import('@/features/public/components/ComponentShowcase'));
// TEMPORÁRIO: showcase dos primitivos do design system novo, usado durante a migração.
const NebiShowcase = lazy(() => import('@/features/public/components/NebiShowcase'));
const AboutUs = lazy(() => import('@/features/public/components/AboutUs'));
const Courses = lazy(() => import('@/features/public/components/Courses'));
const CourseDetails = lazy(() => import('@/features/public/components/CourseDetails'));
const BookClubDetails = lazy(
  () => import('@/features/bookclub/presentation/components/public/BookClubDetails'),
);
const PaymentSuccess = lazy(
  () => import('@/features/payment/presentation/components/PaymentSuccess'),
);
const PaymentCanceled = lazy(
  () => import('@/features/payment/presentation/components/PaymentCanceled'),
);

const LoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
  >
    Carregando...
  </div>
);

export const publicRoutes = [
  {
    path: 'home',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: 'components',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <ComponentShowcase />
      </Suspense>
    ),
  },
  {
    // TEMPORÁRIO: ver §9 do plano de migração — remover quando a migração terminar.
    path: 'components/nebi',
    handle: { ds: 'nebi' },
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <NebiShowcase />
      </Suspense>
    ),
  },
  {
    path: 'conhecanos',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <AboutUs />
      </Suspense>
    ),
  },
  {
    path: 'cursos',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Courses />
      </Suspense>
    ),
  },
  {
    path: 'apresentacaocurso/:id',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <CourseDetails />
      </Suspense>
    ),
  },
  {
    // Tela nova: nasce no DS novo, então a rota declara o `handle` que o MainLayout lê.
    path: 'clube-do-livro/:id',
    handle: { ds: 'nebi' },
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <BookClubDetails />
      </Suspense>
    ),
  },
  {
    path: 'course-details/:id',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <CourseDetails />
      </Suspense>
    ),
  },
  {
    path: 'pagamento/sucesso',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <PaymentSuccess />
      </Suspense>
    ),
  },
  {
    path: 'pagamento/cancelado',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <PaymentCanceled />
      </Suspense>
    ),
  },
];
